// Ce fichier assure que les classes Tailwind personnalisées sont préservées 
// pendant le processus de purge en fournissant des exemples explicites

export const TW_PRESET_CLASSES = [
  // Primary colors
  'bg-primary-50', 'bg-primary-100', 'bg-primary-200', 'bg-primary-300', 
  'bg-primary-400', 'bg-primary-500', 'bg-primary-600', 'bg-primary-700', 
  'bg-primary-800', 'bg-primary-900',
  'text-primary-50', 'text-primary-100', 'text-primary-200', 'text-primary-300', 
  'text-primary-400', 'text-primary-500', 'text-primary-600', 'text-primary-700', 
  'text-primary-800', 'text-primary-900',
  'border-primary-50', 'border-primary-100', 'border-primary-200', 'border-primary-300', 
  'border-primary-400', 'border-primary-500', 'border-primary-600', 'border-primary-700', 
  'border-primary-800', 'border-primary-900',

  // Success colors
  'bg-success-50', 'bg-success-100', 'bg-success-200', 'bg-success-300', 
  'bg-success-400', 'bg-success-500', 'bg-success-600', 'bg-success-700', 
  'bg-success-800', 'bg-success-900',
  'text-success-50', 'text-success-100', 'text-success-200', 'text-success-300', 
  'text-success-400', 'text-success-500', 'text-success-600', 'text-success-700', 
  'text-success-800', 'text-success-900',
  'border-success-50', 'border-success-100', 'border-success-200', 'border-success-300', 
  'border-success-400', 'border-success-500', 'border-success-600', 'border-success-700', 
  'border-success-800', 'border-success-900',

  // Warning colors
  'bg-warning-50', 'bg-warning-100', 'bg-warning-200', 'bg-warning-300', 
  'bg-warning-400', 'bg-warning-500', 'bg-warning-600', 'bg-warning-700', 
  'bg-warning-800', 'bg-warning-900',
  'text-warning-50', 'text-warning-100', 'text-warning-200', 'text-warning-300', 
  'text-warning-400', 'text-warning-500', 'text-warning-600', 'text-warning-700', 
  'text-warning-800', 'text-warning-900',
  'border-warning-50', 'border-warning-100', 'border-warning-200', 'border-warning-300', 
  'border-warning-400', 'border-warning-500', 'border-warning-600', 'border-warning-700', 
  'border-warning-800', 'border-warning-900',

  // Danger colors
  'bg-danger-50', 'bg-danger-100', 'bg-danger-200', 'bg-danger-300', 
  'bg-danger-400', 'bg-danger-500', 'bg-danger-600', 'bg-danger-700', 
  'bg-danger-800', 'bg-danger-900',
  'text-danger-50', 'text-danger-100', 'text-danger-200', 'text-danger-300', 
  'text-danger-400', 'text-danger-500', 'text-danger-600', 'text-danger-700', 
  'text-danger-800', 'text-danger-900',
  'border-danger-50', 'border-danger-100', 'border-danger-200', 'border-danger-300', 
  'border-danger-400', 'border-danger-500', 'border-danger-600', 'border-danger-700', 
  'border-danger-800', 'border-danger-900',
];